module.exports = __webpack_public_path__ + "overlook-studios/img/pal-console-talk.png";